import { Action } from 'redux';
import { select, put, all } from 'redux-saga/effects';
import { UpsellModel, BasketAddonModel, BasketCareKitAddonModel } from 'models/Basket';
import { BasketActionTypes, BasketActions } from '../';
import { AppState, ErrorAction } from 'store';
import { userHelper, errorToBasketErrorModel } from 'helpers';
import { api } from 'repositories/api';
import { upsellsHelper } from 'helpers/upsellsHelper';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface RefreshAvailableUpsellsAction extends Action<BasketActionTypes.REFRESH_AVAILABLE_UPSELLS> {
}

export interface RefreshAvailableUpsellsActionStart extends Action<BasketActionTypes.REFRESH_AVAILABLE_UPSELLS_START> {
}

export interface RefreshAvailableUpsellsActionSuccess extends Action<BasketActionTypes.REFRESH_AVAILABLE_UPSELLS_SUCCESS> {
    availableUpsells: UpsellModel[];
}

export interface RefreshAvailableUpsellsActionError extends ErrorAction<BasketActionTypes.REFRESH_AVAILABLE_UPSELLS_ERROR> {
}

export function* refreshAvailableUpsellsSaga(): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.REFRESH_AVAILABLE_UPSELLS_START,
    });

    try {
        let state: AppState = yield select();
        let userName = userHelper.getCurrentUserName();

        let [
            careKitsAddons,
            sofashieldAddons
        ]: [BasketCareKitAddonModel[], BasketAddonModel[]] = yield all([
            api.hybris.getBasketCareKitsAddons(userName, state.basketState.basket!.guid),
            api.hybris.getBasketSofashieldAddons(userName, state.basketState.basket!.guid)
        ]);

        yield put<BasketActions>({
            type: BasketActionTypes.SAVE_LOADED_CARE_KITS,
            loadedCareKits: careKitsAddons
        });

        let availableUpsells = upsellsHelper.getAvailableUpsells(state.basketState.basket!, careKitsAddons, sofashieldAddons);

        yield put<BasketActions>({
            type: BasketActionTypes.REFRESH_AVAILABLE_UPSELLS_SUCCESS,
            availableUpsells
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.REFRESH_AVAILABLE_UPSELLS_ERROR,
            error: errorToBasketErrorModel(error, 'refreshAvailableUpsellsSaga')
        });

        return false;
    }
}